import { useEffect } from 'react';
import { when } from '@execonline-inc/maybe-adapter';
import { equals } from '@execonline-inc/collections';
import { useOpenable } from '@execonline-inc/execonline-ui';
import useMobileFilterSwitcher from './useMobileFilterSwitcher';

function useMobileSidebarFilterOpenable() {
  const { isOpen, onOpen, onClose } = useOpenable();
  const mode = useMobileFilterSwitcher();

  useEffect(() => {
    when(equals(mode, 'desktop') && isOpen, true).do(onClose);
  }, [isOpen, mode]);

  return { mode, isOpen, onOpen, onClose };
}

export default useMobileSidebarFilterOpenable;
